import styled from "@emotion/styled";

const StyledIgvDiv = styled.div`
 padding: 10px 0;
 width: calc(100% - 20px);
`;

export {StyledIgvDiv};